import Route from '@ember/routing/route'
import type FastPhonicsProgressStudentRoute from 'teacher-ui-client/reporting/ui-scope/fast-phonics/progress/student/route'

export default class FastPhonicsReportingProgressStudentTableRoute extends Route {
  queryParams = {
    sort: {
      replace: true,
    },
  }

  model() {
    const { peaksProgressDetails } = this.modelFor(
      'reporting.ui-scope.fast-phonics.progress.student',
    ) as ModelFor<FastPhonicsProgressStudentRoute>

    const studentData = peaksProgressDetails?.students?.[0]
    if (!studentData) return { studentLessonData: [] }

    const studentLessonData = studentData.lesson_data

    return { studentLessonData }
  }
}
